import Auth0 from './auth0';

export default new Auth0();